import { boot } from 'quasar/wrappers'
import changeWaLocal from '../functions/intel-wa-local'

export default boot(({ app }) => {
	app.config.globalProperties.$changeWaLocal = changeWaLocal
})
